<script>
import { mapActions, mapState } from "vuex";

import ProfessionalSchedule from "../../../../PurchaseFlow/Components/Scheduler/Steps/Professional/Schedule";
import Address from "./Address";

export default {
  components: {
    Address,
    ProfessionalSchedule
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      adddressSelected: false
    };
  },

  methods: {
    ...mapActions("addresses", ["getAddresses"]),
    ...mapActions("orderScheduler", [
      "setProfessionals",
      "setProfessional",
      "confirmProfessional",
      "setScheduleConfirmation",
      "setProfessionalDirectSearch",
      "resetState"
    ]),

    handleAddressSelection() {
      if (!this.adddressSelected && this.selectedAddress) {
        this.setProfessionals([this.order.professional]);
        this.setProfessional(this.order.professional_id);
        this.confirmProfessional();
        this.adddressSelected = true;
        return;
      }

      this.$emit("closeProfessionalSchedule");
    },

    handleProfessionalConfirmation() {
      this.$router.push({ name: "purchase-flow" });
      this.setProfessionalDirectSearch(false);
      this.setScheduleConfirmation();
    }
  },

  computed: {
    ...mapState("orderScheduler", ["selectedAddress", "professionalId"])
  },

  async mounted() {
    await this.getAddresses();
    await this.setProfessionalDirectSearch(true);
  }
};
</script>

<template>
  <Address
    v-if="!adddressSelected"
    :address="this.order.address"
    @onAddressSelection="handleAddressSelection"
    @onReturn="$emit('closeProfessionalSchedule')"
  />

  <ProfessionalSchedule
    v-else-if="adddressSelected && professionalId"
    @scheduleConfirmation="handleProfessionalConfirmation"
    @returnToSearch="adddressSelected = false"
  />
</template>



// WEBPACK FOOTER //
// src/components/Order/Components/Actions/Professional/Index.vue